import { render, staticRenderFns } from "./UpsertModal.vue?vue&type=template&id=124814b6&"
import script from "./UpsertModal.vue?vue&type=script&lang=js&"
export * from "./UpsertModal.vue?vue&type=script&lang=js&"
import style0 from "./UpsertModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports